import { useEffect, useState } from "react";
import { Button } from "~/components/ui/button";
import { cn } from "~/lib/utils";
import ArrowUpward from "@material-design-icons/svg/outlined/arrow_upward.svg?react";

const SCROLL_THRESHOLD = 300;

export function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > SCROLL_THRESHOLD);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <Button
      type="button"
      variant="default"
      size="icon"
      onClick={scrollToTop}
      aria-label="Nach oben scrollen"
      className={cn(
        "fixed bottom-24 right-6 z-50 rounded-full shadow-lg transition-opacity duration-200 w-10 h-10",
        "hover:opacity-90 [&_svg]:size-6",
      )}
    >
      <ArrowUpward className="size-6" aria-hidden />
    </Button>
  );
}
